import React from 'react';
import {view} from '@sail/ui';

import {message, useIntl} from '@sail/intl';

const messages = {
  supportSuccess: message({
    id: 'connectEmbedLib.embeddedSupport.supportSuccess',
    defaultMessage: 'Your support request has been submitted.',
    description: 'Support request success message',
  }),
  supportSuccessSubtitle: message({
    id: 'connectEmbedLib.embeddedSupport.supportSuccessSubtitle:',
    defaultMessage:
      'You should expect a response from one of our support agents in the next 4 - 7 days.',
    description: 'Subtitle for the support success message',
  }),
};

export const EmbeddedSupportSuccess = () => {
  const intl = useIntl();
  return (
    <view.div
      css={{
        padding: 'large',
        stack: 'y',
        textAlign: 'center',
        alignX: 'center',
        alignY: 'center',
      }}
    >
      <view.h3
        css={{
          marginY: 'space.0',
          font: 'heading.medium',
          color: 'text',
          fontWeight: 'regular',
          marginBottom: 'medium',
        }}
      >
        {intl.formatMessage(messages.supportSuccess)}
      </view.h3>
      <view.span
        css={{
          font: 'body.small',
          color: 'subdued',
          marginBottom: 'large',
        }}
      >
        {intl.formatMessage(messages.supportSuccessSubtitle)}
      </view.span>
    </view.div>
  );
};
